import { useSelector } from 'react-redux';

/**
 * useSeatsBus hook.
 * @returns {object} seatsBus - The seats bus state.
 */
function useSeatsBus() {
  const seatsBus = useSelector((state) => state.seatsBus?.toJS?.() || {});
  return seatsBus;
}

export default useSeatsBus;
